import { ErrorHandler, Injectable } from '@angular/core';
import { faro } from '@grafana/faro-web-sdk';
import { EnvironmentService } from '../environment';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService implements ErrorHandler {

  public constructor(private readonly environment: EnvironmentService) {
  }

  public handleError(error: unknown): void {
    if (!this.environment.production()) {
      console.error(error);
    }

    if (!faro.api) {
      return;
    }

    if (error instanceof Error) {
      faro.api.pushError(error);
    } else if (typeof error === 'string') {
      faro.api.pushError(new Error(error));
    } else {
      faro.api.pushError({
        name: 'Unknown Error',
        message: 'Unknown Error in CEP',
        cause: error,
      });
    }
  }
}
